<div class="container" *ngIf="dateItems.length !== 0">
  <div class="date-control">
    <div class="date-field date-field--space-between">
      <div class="date-field__title">Select date</div>
      <div class="ion-float-right date-field-arrows">
        <ion-button class="date-field-arrows__arrow" (click)="prev()" size="small" color="dark" fill="clear">
          <ion-icon class="date-field-arrows__arrow-icon" mode="ios" slot="icon-only" color="dark"
                    name="arrow-back"></ion-icon>
        </ion-button>
        <ion-button class="date-field-arrows__arrow" (click)="next()" size="small" color="dark" fill="clear"
                    slot="icon-only">
          <ion-icon class="date-field-arrows__arrow-icon" mode="ios" slot="icon-only" color="dark"
                    name="arrow-forward"></ion-icon>
        </ion-button>
      </div>
    </div>
    <app-tip-radio-group #dateTipRadio flexCss="0 0 20%" [hasSlide]="true" [items]="dateItems" [(ngModel)]="date"
                         (selectItem)="fullDayPickUpAvailable? chooseFullDay() : dateChanged()" [nextFn]="getNextDates.bind(this)">
      <ng-template let-item let-first="first" #item>
        <div class="date-tip">
          <div class="date-tip__day-week" *ngIf="!isToday(item) else today">{{item | date : 'EEE'}}</div>
          <ng-template #today>
            <div class="date-tip__day-week">Today</div>
          </ng-template>
          <div class="date-tip__day-month" *ngIf="isThisMonth(item) else futureMonth">{{item | date : 'd'}}</div>
          <ng-template #futureMonth>
            <div class="date-tip__day-month">{{item | date : 'M/d'}}</div>
          </ng-template>
        </div>
      </ng-template>
    </app-tip-radio-group>
  </div>
  <div class="date-control">
    <div class="date-field" *ngIf="intervals.length > 0">
      <div class="date-field__title">Select time</div>
    </div>
    <app-tip-radio-group [items]="intervals" flexCss="0 0 33%" [(ngModel)]="timeInterval"
                         [selectedStart]="selectStart" [checkedFn]="isEqualInterval"
                         (selectItem)="selectTime()">
      <ng-container *ngIf="hasAsap(date)">
        <ng-template #start>
          <div class="date-tip" (click)="setAsap()">
            {{asapText}}
          </div>
        </ng-template>
      </ng-container>
      <ng-template let-item let-first="first" #item>
        <div class="date-tip">
          {{formatIntervals(item)}}
        </div>
      </ng-template>
    </app-tip-radio-group>
    <div class="container" *ngIf="intervals.length === 0 && !fullDayPickUpAvailable">
      <div class="container__empty">
        <div class="container__empty-info">
          <span>
            No times available
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container" *ngIf="dateItems.length === 0">
  <div class="container__empty">
    <div class="container__empty-info">
          <span>
            No more pickup days available
          </span>
    </div>
  </div>
</div>
